import { LlmKirjausehdotusKategoria } from './llm-kirjausehdotus-testaus'

export const KIRJAUSEHDOTUS_KATEGORIA_OTSIKOT: Record<LlmKirjausehdotusKategoria, string> = {
  'omalla-rahalla': 'Omalla rahalla',
  'tilitapahtuma-sisaan-myyntilasku': 'Myyntilasku (raha sisään)',
  'tilitapahtuma-sisaan-muu': 'Tilitapahtuma sisään, muu',
  'tilitapahtuma-ulos-hyvityslasku': 'Hyvityslasku (raha ulos)',
  'tilitapahtuma-ulos-ei-tositetta': 'Tilitapahtuma ulos, ei tositetta',
  'tilitapahtuma-ulos-ostolasku-tai-kuitti': 'Tilitapahtuma ulos, ostolasku tai kuitti',
  muu: 'Muu',
}

/**
 * Asiakaskohtaiset AI-kirjausehdotusten asetukset.
 * Firestore: asiakkaat/{asiakasAvain}/muut/llm-kirjausehdotus-asetukset
 */
export interface KirjausehdotusAiAsetukset {
  /** Pääkytkin: tehdäänkö asiakkaalle ehdotuksia lainkaan. Oletus false — asiakas otetaan mukaan kytkemällä erikseen päälle. */
  kaytossa: boolean
  /** Kategoriat joille ehdotuksia tehdään. null = kaikki kategoriat. */
  kategoriat: LlmKirjausehdotusKategoria[] | null
  /** Tehdäänkö ehdotuksia myös olemassa oleville hyväksymättömille tositteille. */
  takautuvat: boolean
  /** Asiakaskohtainen lisäohje LLM:lle (→ moottorin lisaohje-kenttä). */
  lisaohje: string | null
  /** Sallitaanko luotettavien ehdotusten automaattihyväksyntä. */
  automaattihyvaksynta: boolean
}

export const KIRJAUSEHDOTUS_AI_ASETUKSET_LISAOHJE_MAX = 4000

export function annaKirjausehdotusAiAsetuksetUri(asiakasAvain: string): string {
  return `asiakkaat/${asiakasAvain}/muut/llm-kirjausehdotus-asetukset`
}

export const KIRJAUSEHDOTUS_AI_ASETUKSET_OLETUS: KirjausehdotusAiAsetukset = {
  kaytossa: false,
  kategoriat: null,
  takautuvat: false,
  lisaohje: null,
  automaattihyvaksynta: false,
}
